import { Lender, LenderClient, Product, ProductClient } from "@src/apis/ModularClient";

export class ProductController {
  selectedSection: string;

  objects: Product[];
  selectedObject: Product;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  lenderRecords: Lender[];

  //addingSubobject: boolean;

  //subobjects: SubobjectDTO[];
  //selectedSubobject: SubobjectDTO;

  //fetchingSubobjects: boolean;
  //fetchingSubobject: boolean;

  productForm: ng.IFormController;
  //subproductForm: ng.IFormController;

  static $inject = ["$routeParams", "ProductClient", "LenderClient"];
  //private $subobjectservice: App.Services.SubobjectService
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $productClient: ProductClient,
    private lenderClient: LenderClient,
  ) {
    this.updateObjects();
  }

  updateObjects() {
    this.fetchingObjects = true;

    // Fetch all objects.
    this.$productClient
      .list()
      .then((response) => {
        this.objects = response;
        this.preSelectedItem();
      })
      .finally(() => {
        this.fetchingObjects = false;
      });
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  selectObject(object: Product) {
    this.selectedObject = object;

    //this.fetchingSubobjects = true;
    //this.$subobjectservice.fetchSubobjectsForObject(object.Id).then((response) => {
    //    this.subobjects = response;
    //    this.fetchingSubobjects = false;
    //}).catch((response) => {
    //    this.fetchingSubobjects = false;
    //});

    this.selectedSection = "details";
  }

  createObject() {
    this.selectedSection = "details";
    this.selectedObject = {} as Product;
  }

  save() {
    this.$productClient.addUpdateReturnOnlyID(this.selectedObject).then((response) => {
      this.selectedObject.id = response;
      if (!this.objects) {
        this.objects = [];
      }

      let matches: Product[] = this.objects.filter((value, index) => {
        return value.id == response;
      });

      if (!matches || matches.length === 0) {
        this.objects.push(this.selectedObject);
      }

      this.productForm.$setPristine();
      this.updateObjects();
    });
  }

  delete() {
    this.$productClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.productForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }

  getlenders() {
    this.lenderClient
      .fetchAll()
      .then((response) => {
        this.lenderRecords = response;
      })
      .finally(() => {});
  }

  //addSubobject() {
  //    this.selectedSubobject = {
  //        AssociatedObjectId: this.selectedObject.id,
  //        AssociatedObjectName: this.selectedObject.name
  //    } as SubobjectDTO;
  //}

  //removeSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.deleteSubobject(subobject.Id).then((response) => {
  //        this.subobjects.splice(this.subobjects.indexOf(this.selectedSubobject), 1);
  //        delete this.selectedSubobject;
  //    });
  //}

  //cancelUpdateSubobject() {
  //    delete this.selectedSubobject;
  //}

  //updateSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.addUpdateSubobject(subobject).then((response) => {
  //        if (this.subobjects.indexOf(subobject) === -1) {
  //            this.subobjects.push(subobject);
  //        }
  //        delete this.selectedSubobject;
  //    }).catch((response) => {
  //        delete this.selectedSubobject;
  //    });

  //}
}
